import styled from 'styled-components/macro';

import * as colors from 'components/common/colorConstants';
import { DefaultText } from '../../common/fontElements';

export const HeaderRow = styled.div`
  min-height: 5rem;
  padding: 10px 32px;
  display: flex;
  align-items: center;
  flex-wrap: nowrap;
  max-height: 54px;
  border-bottom: 1px solid ${colors.decisionTreeButtonHoverBackground};

  @media (max-width: 1366px) {
    min-height: 45px;
  }
`;

export const BackButton = styled.img`
  padding: 0px 10px 0px 0px;
  cursor: pointer;
`;

export const TaskPageWrapper = styled.div`
  height: 100%;
  width: 100%;
`;

export const OrderNumberLabel = styled(DefaultText)`
  .tooltip-icon {
    margin-left: 5px;
  }
`;

export const LoadingContainer = styled.div`
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const ShopifyWrapper = styled.div`
  background-color: ${colors.baseBackground};
  z-index: 3;
  height: 100%;
  overflow: auto;
`;
